module.exports = __webpack_public_path__ + "img/bg-section-09.fa28dd85.svg";